import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';

export const useConditionChoices = () => {
  const translate = useTypedTranslate();

  return [
    { id: true, name: translate('app.statuses.archive') },
    { id: false, name: translate('app.statuses.active') },
  ];
};
